export const PARTNER_LIST_ATTRIBUTES_CONSTANT = {
  search: {
    type: 'text',
    key: 'search',
    label: 'Search',
    placeholder: 'name/email',
  },
} as const;
